import { render } from "./BillingViewModal.vue?vue&type=template&id=fa9589f6"
import script from "./BillingViewModal.vue?vue&type=script&lang=js"
export * from "./BillingViewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__